<template>
	<Modal :closeButton="closeButton" :title="title" @close="close()" :zIndex="118">
		<template v-slot:content>
			<div class="content">
				<div>We will apply the following selections bilaterally unless otherwise directed by you <ins>within the notes section.</ins></div>
				<div>
					<ul>
						<li>Other Shell Modifications*</li>
						<li>Other Coverings</li>
						<li>Other Accommodations</li>
					</ul>
				</div>
				<div>
					<em>*Other Shell Modifications will not be displayed in the design inspector.</em>
				</div>
				<div>
					To learn more about each of these please review our
					<a href="https://reinvent.hp.com/us-en-arizeclinical-support#Setup" target="_blank">Prescripion Guide</a> available on the support website.
				</div>
			</div>
		</template>
		<template v-slot:footer>
			<div class="buttons">
				<!--  <button v-if="leftButtonText !== ''" @click="leftButtonAction()" class="button-blank-color roundButton">{{ leftButtonText }}</button> -->
				<button v-if="buttonText !== ''" @click="close()" class="button-primary-color roundButton">{{ buttonText }}</button>
			</div>
		</template>
	</Modal>
</template>

<script>
	import Modal from '../Modal';

	export default {
		name: 'SpecialRxHelpModal',
		components: { Modal },
		props: {
			text: String,
			title: String,
			buttonText: String,
			buttonAction: Function,
			closeButton: Boolean,
			narrowMode: Boolean
		},
		methods: {
			close() {
				this.$emit('close');
			}
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		text-align: left;
		padding: var(--step-5);
		display: flex;
		flex-direction: column;
		font-weight: 400;
		font-size: 16px;
		gap: 1.5rem;
		/*height: 100%;*/
		// align-items: center;
		// justify-content: center;
	}
	.text {
		font-size: 16px;
		font-weight: 400;
	}
	.content_narrow {
		text-align: left;
		padding: var(--step-5);
		display: flex;
		/*height: 100%;*/
		align-items: center;
		justify-content: center;
	}

	.buttons {
		display: flex;
		justify-content: space-evenly;
		width: 100%;
		min-width: 45vw;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 9rem; // use px becasue I was forced to do it.
			height: 2.5vw;
			border-radius: 72px;
			font-weight: 500;
			color: white;
		}

		padding-bottom: calc(var(--step-5) / 2);
	}
	.buttons_narrow {
		display: flex;
		justify-content: center;
		width: 100%;
		min-width: 45vw;
		gap: 2rem;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 12vw;
			height: 2.5vw;
			border-radius: 72px;
		}
		padding-bottom: calc(var(--step-5) / 2);
	}
</style>
